import { render, staticRenderFns } from "./LoldocupIntro.vue?vue&type=template&id=5fac1f68&"
import script from "./LoldocupIntro.vue?vue&type=script&lang=js&"
export * from "./LoldocupIntro.vue?vue&type=script&lang=js&"
import style0 from "./LoldocupIntro.vue?vue&type=style&index=0&id=5fac1f68&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports